export interface AgendaTopicBody {
  topic: string | null
  body: string
}

/** Split "Topic: body" at the first colon; topic includes the colon when present. */
export function splitAgendaTopicBody(line: string): AgendaTopicBody {
  const idx = line.indexOf(':')
  if (idx <= 0) {
    return { topic: null, body: line.trim() }
  }
  return {
    topic: line.slice(0, idx + 1).trim(),
    body: line.slice(idx + 1).trimStart(),
  }
}

export function isAgendaEmpty(agenda: {
  progress: string[]
  decisions: string[]
  questions: string[]
  risks: string[]
}): boolean {
  return (
    agenda.progress.length === 0 &&
    agenda.decisions.length === 0 &&
    agenda.questions.length === 0 &&
    agenda.risks.length === 0
  )
}
